let activeScroll = null;

function contentTop(element) {
  const header = document.querySelector(".admin-header");
  const offset = header ? header.getBoundingClientRect().height + 16 : 16;
  return element?.isConnected
    ? Math.max(0, window.scrollY + element.getBoundingClientRect().top - offset)
    : 0;
}

export function cancelContentScroll() {
  activeScroll?.();
}

// Native smooth scrolling can be cancelled when a loading table changes height.
// Keep one animation, measure the target during it, and let deliberate user input cancel it.
export function scrollToContent(element = null) {
  cancelContentScroll();
  const root = document.documentElement;
  const previousBehavior = root.style.getPropertyValue("scroll-behavior");
  const previousPriority = root.style.getPropertyPriority("scroll-behavior");
  root.style.setProperty("scroll-behavior", "auto", "important");
  let frame;
  let stopped = false;
  const cleanup = () => {
    if (stopped) return;
    stopped = true;
    window.cancelAnimationFrame(frame);
    window.removeEventListener("wheel", cancel);
    window.removeEventListener("touchstart", cancel);
    window.removeEventListener("pointerdown", cancel);
    window.removeEventListener("keydown", onKeyDown);
    if (previousBehavior) root.style.setProperty("scroll-behavior", previousBehavior, previousPriority);
    else root.style.removeProperty("scroll-behavior");
    if (activeScroll === cancel) activeScroll = null;
  };
  const cancel = () => cleanup();
  const onKeyDown = (event) => {
    if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "].includes(event.key)) cancel();
  };
  activeScroll = cancel;
  // Move focus off the old bottom paginator. Otherwise it can pull the viewport
  // back down when the response replaces the loading rows.
  if (element?.isConnected) {
    if (!element.hasAttribute("tabindex")) element.setAttribute("tabindex", "-1");
    element.focus({ preventScroll: true });
  }
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
    window.scrollTo({ top: contentTop(element), left: 0, behavior: "auto" });
    cleanup();
    return cancel;
  }
  window.addEventListener("wheel", cancel, { passive: true });
  window.addEventListener("touchstart", cancel, { passive: true });
  window.addEventListener("pointerdown", cancel, { passive: true });
  window.addEventListener("keydown", onKeyDown);
  const start = window.scrollY;
  let startedAt;
  const animate = (now) => {
    if (stopped) return;
    if (startedAt === undefined) startedAt = now;
    const progress = Math.min(1, (now - startedAt) / 420);
    const eased = 1 - Math.pow(1 - progress, 3);
    window.scrollTo({ top: start + (contentTop(element) - start) * eased, left: 0, behavior: "auto" });
    if (progress < 1) frame = window.requestAnimationFrame(animate);
    else cleanup();
  };
  frame = window.requestAnimationFrame(animate);
  return cancel;
}

export function findListStart(control) {
  let region = control?.parentElement;
  while (region) {
    const target = region.querySelector("[data-list-start]");
    if (target) return target;
    if (region.matches(".admin-content")) return region;
    region = region.parentElement;
  }
  return document.querySelector(".admin-content");
}

export function scheduleContentScroll(target = null) {
  cancelContentScroll();
  let cancelAnimation;
  const cancel = () => {
    window.cancelAnimationFrame(frame);
    cancelAnimation?.();
    if (activeScroll === cancel) activeScroll = null;
  };
  const frame = window.requestAnimationFrame(() => {
    if (activeScroll === cancel) activeScroll = null;
    cancelAnimation = scrollToContent(target);
  });
  activeScroll = cancel;
  return cancel;
}
